export default function Stepper({ steps, current, maxStep, onSelect }) {
    return (
        <div className="bt-stepper">
            {steps.map((s, i) => {
                const reached = i <= maxStep
                const active = i === current
                return (
                    <button
                        key={s.key}
                        className={`bt-step ${active ? "bt-step-active" : ""} ${reached ? "" : "bt-step-locked"}`}
                        disabled={!reached}
                        onClick={() => onSelect(i)}
                    >
                        <span className="bt-step-num">{i + 1}</span>
                        <span className="bt-step-label">{s.label}</span>
                    </button>
                )
            })}
        </div>
    )
}
